import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { Company, CompanyCreateReq } from 'src/app/models/user/company.model';
import {
  LogIn,
  LogInResponse,
  RefreshTokenReq,
} from 'src/app/models/user/login.model';
import {CurrentUserResponse, User} from 'src/app/models/user/user.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {

  constructor(private http: HttpClient) {}

  public generateToken(loginData: LogIn) {
    return this.http.post<LogInResponse>(
      `${environment.apis.login.SIGN_IN}`,
      loginData
    );
  }

  //Seteamos el token en el local storage 
  public setToken(token: string) {
    localStorage.setItem('token', token);
  }
    /* TODO: Obtenemos el token */
    public getToken() {
      return localStorage.getItem('token');
    }

  public getCurrentUser() {
    return this.http.get<CurrentUserResponse>(
      `${environment.apis.login.CURRENT_USER}`
    );
  }

  /* TODO: Validamos que el token este guardao en el local storage */
  public isLogin() {
    let tokenStr = localStorage.getItem('token');
    return !(tokenStr == undefined || tokenStr == '' || tokenStr == null);
  }

  /* Validamos que este logueado el usuario */
  public isLoggedIn() {
    let tokenStr = localStorage.getItem('token');
    return !(tokenStr == undefined || tokenStr == '' || tokenStr == null);
  }

  /* TODO: Cerramos sesion y limpiamos el local storage */
  public logout() {
    localStorage.removeItem('token');
    // localStorage.removeItem('user');
    // localStorage.removeItem('company')
    return true;
  }


  /* TODO: Seteamos el usuario */
  public setUser(user: any) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  /* TODO: Seteamos el company */
  public setCompany(company: any) {
    localStorage.setItem('company', JSON.stringify(company));
  }

  /* TODO: Obtenemos el usuario */
  public getUser() {
    let userStr = localStorage.getItem('user');
    if (userStr != null) {
      return JSON.parse(userStr);
    }

    this.logout();
    return null;
  }

    /* TODO: Obtenemos los roles */
    public getUserRole() {
      let user = this.getUser();
      if (user) {
        return user.authorities[0].authority;
      }
      return null;
    }
    
  public getUsername() {
    let user = this.getUser();
    return user.username;
  }



  public refreshTokenService(
    token: RefreshTokenReq
  ): Observable<LogInResponse> {
    return this.http.post<LogInResponse>(
      `${environment.apis.login.REFRESH_TOKEN}`,
      token
    );
  }
  getIdCompany( idComany: string ) {
    return this.http.get<Company>(
      `${environment.apis.company.GET_ID}/${idComany}`
    );
  }
  getRucCompany( idComany: string ) {
    return this.http.get<Company>(
      `${environment.apis.company.GET_RUC}/${idComany}`
    )
  }

  createCompany(company: CompanyCreateReq) {
    return this.http
      .post<Company>(`${environment.apis.company.POST}`, company);
  }
}
